import { apiRequest } from './client';
import type { PushRepository } from '../../application/ports/PushRepository';

export class HttpPushRepository implements PushRepository {
  registerSubscription(sub: { endpoint: string; keys: { p256dh: string; auth: string } }) {
    return apiRequest<void>('/push/subscribe', { method: 'POST', body: JSON.stringify(sub) });
  }

  unregisterSubscription(endpoint: string) {
    return apiRequest<void>('/push/subscribe', { method: 'DELETE', body: JSON.stringify({ endpoint }) });
  }
}
